import { GETRequestResponse } from '@cbgms/api'
import useQuery from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { getProductWarrantyClaimDetails } from '../state/actions'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const useGetProductWarrantyClaimDetails = (UUID: string) => {
  const dispatch = useDispatch()

  return useQuery(
    ['support-product-warranty-claims', UUID as string],
    async () => {
      const { Data } = await dispatch(AsyncAction<GETRequestResponse>(getProductWarrantyClaimDetails(UUID as string)))
      return Data
    },
    { refetchOnWindowFocus: false }
  )
}
